import { render, staticRenderFns } from "./SliderProfile.vue?vue&type=template&id=24c132a1&"
import script from "./SliderProfile.vue?vue&type=script&lang=js&"
export * from "./SliderProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports